import { Col, Row } from "reactstrap";
import REAL from "../../../assets/RealEnglishImages/REAL.png"
const Welcome = () => {
  return (
    <Row className="justify-content-center">
      <Col lg={8} sm={10}>
        <div className="text-center mt-lg-5 px-5 pb-2">
          <h1 className="display-5 fw-bold  mb-3 lh-base">
         
            <Col xs={12} className="d-flex justify-content-center">   <span className="text-primary d-flex align-items-start justify-content-center"> <span className="pe-3">At </span>      </span>  <img src={REAL} className="card-logo card-logo-dark" alt="logo dark" height="57"/></Col>
             {/* <span style={{fontSize:"60px",color:"#5bc3c6"}}>R </span> <span style={{fontSize:"60px",color:"#edbd33"}}>E </span> <span style={{fontSize:"60px",color:"#f3a5d4"}}>A </span> <span style={{fontSize:"60px",color:"#bacf9a"}}>L</span>  */}
             <Col xs={12}>English Academy</Col>
          </h1>
          <p className="lead lh-base">
             we
            believe English isn’t just something you study—it’s something you{" "}
            <span className="text-info">experience!</span>
          </p>
          <p className="lead lh-base">
            That’s why our approach is different. We don’t just teach grammar;
            we bring English to life through communication, hands-on activities,
            and interactive games that make learning fun, engaging, and natural.
          </p>
          <div className="d-flex justify-content-center mt-4">
            <div className="p-3 text-center">
              <i className="mdi mdi-gamepad-variant fs-36 text-warning"></i>
              <p className="mt-2 ">Interactive Learning</p>
            </div>
            <div className="p-3 text-center">
              <i className="mdi mdi-human-male-board-poll fs-36 text-primary"></i>
              <p className="mt-2 ">Expert Instructors</p>
            </div>
            <div className="p-3 text-center">
              <i className="mdi mdi-trophy fs-36 text-success"></i>
              <p className="mt-2 ">Award-Winning Facilities</p>
            </div>
          </div>
          <p className="lead  lh-base mt-3">
             Our commitment to innovation was recognized with the 
            <strong className=" ps-1  text-primary">
              Excellence in School Facilities
            </strong>
            award in 2024, celebrating our vibrant learning spaces designed to
            spark curiosity, creativity, and confidence.
          </p>
        </div>
      </Col>
    </Row>
  );
};
export default Welcome;
